// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-js{color:#000;font-size:.75rem}.video-js .vjs-control-bar{background-color:#fff}.video-js .vjs-load-progress,.video-js .vjs-play-progress,.video-js .vjs-volume-bar,.video-js .vjs-volume-level{background-color:gray}.video-js .vjs-slider{background-color:#d3d3d3}.video-js button{color:#000}.video-js button:focus{outline:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
